import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"

import "./index.vue?vue&type=style&index=0&id=99043736&lang=scss"
import "./index.vue?vue&type=style&index=1&id=99043736&lang=scss"

const __exports__ = script;

export default __exports__